import PasswordStep from '../../steps/PasswordStep';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const PASSWORD_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.PASSWORD,
  options: { countsTowardProgressBar: false, hideProgressBar: true },
  elements: [
    {
      uid: OnboardingStepType.PASSWORD,
      component: (
        <PasswordStep
          uid={OnboardingStepType.PASSWORD}
          nodeType={OnboardingNodeType.PASSWORD}
          displayName=""
          actionButtonText="Next"
        />
      )
    }
  ]
};
